export default {
  zh: {
    quotation: "服务报价单",
    reminders: "注意事项:",
    describe01: "- 当你点击按钮“报价申请-提交”后，报价明细将由EStar后台更新，请耐心等待。",
    describe02: "- EStar将线下联系您、跟您沟通服务报价明细，并将服务报价信息更新至步骤4的界面里，以便你完成后续的操作。",
    describe03: "- 若您在未来2个工作日内未收到EStar的联系，请联系我们本系统的客服，我们将尽快给您回复。",
    applicationsButton: "报价申请 – 提交",
    toolTip: "点击本按钮提交报价申请，我们的工作人员将在收到报价咨询后的48小时内联系你、了解你的需求以及提供你定制化服务的报价。",
    comprehensiveTitle: "综合性公司服务(定制化)",
    comprehensiveTitle02: "Comprehensive Corporate Services (customized) 综合性公司服务(定制化)",
    fundAdminTitle: "基金托管服务(定制化)",
    fundAdminTitle02: "Fund Admin Services (customized) 基金托管服务(定制化)",
    payment: "期付款",
    downPayment: "期应支付金额",
    reminder: "提醒事项:",
    reminderContent: "服务报价明细请详见《收费协议》",
    paymentSchedule: "支付方式",
    feeLetter: "服务报价书",
    demand: "请输入您的需求",
    requirements: "您需要什么类型的服务?",
    quotationNumber: "报价申请单号",
    lastSubmittedDate: "最近一次提交时间",
    theBid: "报价完成",
    theBidTipe: "点击按钮“下一步”查看报价详情",
    linkedTransactionRenewed: "关联的交易号码(续约服务的原订单号)",
    linkedTransactionSupplements: "关联的交易号码(增加服务的原订单号)",
  },
  en: {
    quotation: "Quotation",
    reminders: "Reminders:",
    describe01: '- Details of the quotation will be updated by EStar after you clicking on the button "Quotation Request - Submit".',
    describe02:
      "- EStar will contact you offline, communicate with you about the service quotation details, and update the service quotation information in this system (i.e. Step 4-Confirm) screen so that you can complete the following operations.",
    describe03: "- If you are not contacted by EStar within the next 2 workings days, please contact our customer services shown in this system for immediate reply.",
    applicationsButton: "Quotation Request - Submit",
    toolTip:
      "Click this button to submit your quotation request. Our staff will contact you within 48 hours after receiving this request. We will understand your needs first and then provide you the quotation for customized services.",
    comprehensiveTitle: "Comprehensive Corporate Services (customized)",
    comprehensiveTitle02: "Comprehensive Corporate Services (customized)",
    fundAdminTitle: "Fund Admin Services (customized)",
    fundAdminTitle02: "Fund Admin Services (customized)",
    payment: "payment",
    downPayment: "payment due",
    reminder: "Reminder:",
    reminderContent: 'Please see "Fee Letter" for the details of our services.',
    paymentSchedule: "Payment Schedule",
    feeLetter: "Fee Letter",
    demand: "Please enter your requirements",
    requirements: "What type of services do you need?",
    quotationNumber: "The Quotation Number",
    lastSubmittedDate: "The last submitted date",
    theBid: "Quotation Proposed",
    theBidTipe: 'Click button "next" for quotation details',
    linkedTransactionRenewed: "Linked Transaction No. (Be Renewed)",
    linkedTransactionSupplements: "Linked Transaction No. (Have Supplements)",
  },
};
